import {
  STRING_VALIDATION_REGEX, NUMBER_VALIDATION_REGEX, EMAIL_VALIDATION_REGEX, ZIP_REGEX,
} from '../constants/AppConstants';

/**
 * Used for performing particular validation for the field and field value received
 * @param {string} fieldName - name of field whose value is to be validated
 * @param {string} fieldValue - value to be validated
 */
const validateValue = ({ mandatoryFields, numberFields, stringFields }, fieldName, fieldValue, abbreviation) => {
  if (mandatoryFields[fieldName] && !fieldValue) {
    return `${mandatoryFields[fieldName]} is required`;
  }

  if (numberFields && numberFields[fieldName] && fieldValue && !NUMBER_VALIDATION_REGEX.test(fieldValue)) {
    return `${numberFields[fieldName]} must be a number`;
  }

  if (stringFields && stringFields[fieldName] && fieldValue && !STRING_VALIDATION_REGEX.test(fieldValue)) {
    return `${stringFields[fieldName]} must be a string`;
  }

  if (fieldName === 'phone' && String(fieldValue).length < 10) return 'Phone number must be 10 digits';

  if (fieldName === 'zipCode' && fieldValue
    && ZIP_REGEX[abbreviation] !== undefined && !ZIP_REGEX[abbreviation].test(fieldValue)) {
    return 'Zip code is invalid';
  }

  if (fieldName === 'email' && !EMAIL_VALIDATION_REGEX.test(fieldValue)) {
    return 'Email address must be valid';
  }

  return '';
};

export default validateValue;
